import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFeaturedDramas } from "@/utils/content";

export default function HeroCarousel() {
  const slides = getFeaturedDramas();
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return;
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [slides.length]);

  if (slides.length === 0) return null;

  const go = (dir: number) => {
    setActive((prev) => (prev + dir + slides.length) % slides.length);
  };

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="relative h-[420px] w-full md:h-[560px] lg:h-[600px]">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={slide.banner}
              alt={`${slide.title} 剧照`}
              title={`${slide.title} 剧情亮点`}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/20"></div>
          </div>
        ))}

        <div className="relative mx-auto flex h-full w-full max-w-[1280px] flex-col justify-center px-4 md:px-6">
          <div key={slides[active].id} className="max-w-2xl animate-fade-up">
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-fire-fill"></i>
              焦点推荐 · {slides[active].category}
            </span>
            <h1 className="mt-4 font-heading text-3xl font-bold text-white md:text-5xl lg:text-6xl">
              {slides[active].title}
            </h1>
            <div className="mt-3 flex flex-wrap items-center gap-3 text-sm text-white/85">
              <span className="flex items-center gap-1 text-accent-300">
                <span className="flex h-4 w-4 items-center justify-center"><i className="ri-star-fill"></i></span>
                {slides[active].rating} 分
              </span>
              <span>{slides[active].genre}</span>
              <span className="hidden sm:inline">{slides[active].year}</span>
              <span className="hidden sm:inline">{slides[active].region}</span>
            </div>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/80 md:text-base">
              {slides[active].synopsis}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${slides[active].id}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center"><i className="ri-play-circle-line"></i></span>
                查看详情
              </Link>
              <Link
                to="/category"
                className="whitespace-nowrap rounded-md border border-white/40 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-white/10"
              >
                浏览全部影视
              </Link>
            </div>
          </div>

          <div className="mt-6 flex items-center gap-2">
            {slides.map((slide, index) => (
              <button
                key={slide.id}
                type="button"
                aria-label={`切换到 ${slide.title}`}
                onClick={() => setActive(index)}
                className={`h-2 rounded-full transition-all ${
                  index === active ? "w-8 bg-primary-400" : "w-2 bg-white/50 hover:bg-white/80"
                }`}
              />
            ))}
          </div>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(-1)}
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/30 text-white transition-colors hover:bg-black/50 md:flex"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(1)}
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/30 text-white transition-colors hover:bg-black/50 md:flex"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}